import {RestrictionItem} from '@app/core/model/filtering/restriction-item';
import {RequestedFilterModel} from '@app/core/model/integration-models';
import {RestrictionFilter} from '@app/core/model/filtering/restriction-filter';

export class RestrictionRule implements RestrictionItem {
    entityFilterId: string;
    items: RestrictionFilter[];
    uniqId: string;
    modifiedBy: RequestedFilterModel;

    static isEqual(a: RestrictionRule, b: RestrictionRule): boolean {
        // Don't compare items because it cause circular dependencies
        return a && b && (
            (a.uniqId === b.uniqId)
            && (a.entityFilterId === b.entityFilterId)
            && (!!a.modifiedBy === !!b.modifiedBy)
            && (!a.modifiedBy || RequestedFilterModel.isEqual(a.modifiedBy, b.modifiedBy))
        );
    }

    constructor() {
        this.items = [];
        this.uniqId = Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15);
    }

    isAllCompleted(): boolean {
        return this.items.filter(item => !item.isCompleted()).length === 0;
    }

    addItem(newItem: RestrictionFilter) {
        newItem.rule = this;
        // newItem.restriction = this.restriction;
        this.items.push(newItem);
    }

    deleteItem(item: RestrictionFilter) {
        this.items = this.items.filter(it => it !== item);
    }

    resetItem(item: RestrictionFilter) {
        this.items.forEach((it: RestrictionFilter) => {
            if (it.uniqId === item.uniqId) {
                it.attribute = null;
                it.predicate = item.getAvailablePredicates().filter(p => p.name === 'Contains')[0];
                it.value = null;
                it.entity = item.entity;
            }
        });
    }

    isCompleted() {
        let resp = true;
        this.items.forEach(item => {
            resp = resp && !!item.isCompleted();
        });
        return resp && this.items.length > 0;
    }

    equals(rule: RestrictionRule): boolean {
        return RestrictionRule.isEqual(this, rule);
    }
}
